import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import puzzlesCarouselData from "./Components/Data/HomeCarousel";
import logo from "./Components/Assets/Logo.svg";
import streak from "./Components/Assets/Streak.svg";
import points from "./Components/Assets/Points.svg";
import notify from "./Components/Assets/Notify.svg";
import profile from "./Components/Assets/Profile.svg";

import gameReview from "./Components/Assets/Game-review-home.svg";
import visualisation from "./Components/Assets/Visualisation-home.svg";
import book from "./Components/Assets/Book-home.svg";
import collection from "./Components/Assets/Collection.svg";
import notes from "./Components/Assets/Notes.svg";
import ai from "./Components/Assets/AI-home.svg";
import whoIsWinning from "./Components/Assets/WhoIsWinning.svg";
import social from "./Components/Assets/Social.svg";
import puzzles from "./Components/Assets/Puzzles-home.svg";
import more from "./Components/Assets/More.svg";
import subscription from "./Components/Assets/Subscription.svg";
import settings from "./Components/Assets/Settings.svg";
import logout from "./Components/Assets/Logout.svg";
import board1 from "./Components/Assets/Board-CasualPuzzles.svg";
import board2 from "./Components/Assets/Board-PersonalisedPuzzles.svg";
import board3 from "./Components/Assets/Board-ClassicalPuzzles.svg";
import leftPage from "./Components/Assets/Left-PageHome.svg";
import collapseLeftbar from "./Components/Assets/CollapseLeftbar-home.svg";
import left from "./Components/Assets/Left.svg";
import right from "./Components/Assets/Right.svg";
import searchSvg from "./Components/Assets/Search.svg";
import searchReview from "./Components/Assets/SearchImport.svg";

import downFooter from "./Components/Assets/Down-FooterHome.svg";
import instaSvg from "./Components/Assets/Insta-home.svg";
import youtubeSvg from "./Components/Assets/Youtube-home.svg";
import threadsSvg from "./Components/Assets/Threads-home.svg";
import twitterSvg from "./Components/Assets/Twitter-home.svg";
import linkedninSvg from "./Components/Assets/Linkedin-home.svg";
import copyrightsSvg from "./Components/Assets/Copyrights-home.svg";

import rightArrow from "./Components/Assets/Right-arrow.svg";
import gameReviewCenter from "./Components/Assets/GameReview-CenterHome.svg";
import puzzleRushIcon from "./Components/Assets/PuzzleRushIcon-Home.svg";
import puzzleBattleIcon from "./Components/Assets/PuzzleBattleIcon-Home.svg";
import challengeBotIcon from "./Components/Assets/ChallengeBotIcon-home.svg";
import compare from "./Components/Assets/Compare.svg";
import opponent from "./Components/Assets/Opponent.svg";
import question from "./Components/Assets/QuestionMark.svg";
import gameRegistry from "./Components/Assets/GameRegistry-home.svg";
import filterIcon from "./Components/Assets/Filter-home.svg";
import graphRegistry from "./Components/Assets/Graph-home.svg";
import gameReviewBoard from "./Components/Assets/Board-GamereviewHome.svg";
import dailyPuzzleBoard from "./Components/Assets/Board-DailyPuzzleHome.svg";
import puzzleRushBoard from "./Components/Assets/Board-PuzzleRushHome.svg";
import puzzleBattleBoard from "./Components/Assets/Board-PuzzleBattleHome.svg";
import challengeBotBoard from "./Components/Assets/Board-ChallengeBotHome.svg";

export const Home = () => {
  const [hovered, setHovered] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [search, setSearch] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const navigate = useNavigate();

  const [puzzleCarousels, setPuzzleCarousels] = useState(puzzlesCarouselData);
  const [index, setIndex] = React.useState(0);

  useEffect(() => {
    const lastIndex = puzzleCarousels.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, puzzleCarousels]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
    }, 5000);
    return () => {
      clearInterval(slider);
    };
  }, [index]);

  const handleMouseEnter = (text) => {
    setHovered(text);
  };

  const handleMouseLeave = () => {
    setHovered("");
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };
  const handleLogout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");

    sessionStorage.clear();

    navigate("/login", { replace: true });
  }, [navigate]);
  return (
    <div className="container-home">
      <div className="container-header-center home-phone-shell">
        <header className="header home-phone-primarybar">
          <div className="home-logo-lockup">
            <img className="logo-image" src={logo} alt="logo" />
            <div className="logo-text">
              <span className="C-logo">C</span>
              <span className="hezzle-logo">
                he<span className="Z-1">Z</span>
                <span className="Z-2">Z</span>le
              </span>
            </div>
          </div>

          <div className="search-header-home">
            <div className="search-bg-header-home">
              <img
                src={searchSvg}
                className="search-header-home-svg"
                alt="svg"
              />
            </div>
            <form className="form-search-header">
              <input
                type="text"
                placeholder="Search for a feature, game, etc."
                className="search-input-header-home"
                onChange={(e) => setSearch(e.target.value)}
              />
            </form>
          </div>

          <div className="streak-header-home">
            <img src={streak} className="streak-header-home-svg" alt="svg" />
            <h3 className="streak-text-header-home">985</h3>
          </div>

          <div
            className="points-header-home"
            onClick={() => handleNavigation("/Points")}
          >
            <img src={points} className="points-header-home-svg" alt="svg" />
            <h3 className="points-text-header-home">8453</h3>
          </div>

          <div className="notify-header-home">
            <img src={notify} className="notify-header-home-svg" alt="svg" />
            <div className="notify-dot-header-home"></div>
          </div>

          <div
            className="profile-header-home"
            onClick={() => handleNavigation("/Profile")}
          >
            <img src={profile} className="profile-header-home-svg" alt="svg" />
            <div className="profile-username-header-home">Snehal2703</div>
          </div>
        </header>
        <div className="gradient-line home-phone-divider"></div>

        {!collapsed && (
          <div className="left-bar-home home-phone-nonessential">
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/GameReview")}
            >
              <img
                className="gameReview-home-svg"
                src={gameReview}
                alt="svg"
                onMouseEnter={() => handleMouseEnter("Game Review")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Game Review" && (
                <span className="hover-text">Game Review</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Visualisation")}
            >
              <img
                className="visualisation-home-svg"
                src={visualisation}
                alt="svg"
                onMouseEnter={() => handleMouseEnter("Visualisation")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Visualisation" && (
                <span className="hover-text">Visualisation</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Book")}
            >
              <img
                className="book-home-svg"
                src={book}
                alt="svg"
                onMouseEnter={() => handleMouseEnter("Book")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Book" && <span className="hover-text">Book</span>}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Collection")}
            >
              <img
                className="collection-home-svg"
                src={collection}
                alt="svg"
                onMouseEnter={() => handleMouseEnter("Collection")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Collection" && (
                <span className="hover-text">Collection</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Notes")}
            >
              <img
                className="notes-home-svg"
                src={notes}
                alt="svg"
                style={{ width: "25.5px" }}
                onMouseEnter={() => handleMouseEnter("Notes")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Notes" && <span className="hover-text">Notes</span>}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Analyse")}
            >
              <img
                className="ai-home-svg"
                src={ai}
                alt="svg"
                style={{ width: "35px" }}
                onMouseEnter={() => handleMouseEnter("Analyse")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Analyse" && (
                <span className="hover-text">Analyse</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/WhoIsWinning")}
            >
              <img
                className="whoIsWinning-home-svg"
                src={whoIsWinning}
                alt="svg"
                style={{ width: "26px" }}
                onMouseEnter={() => handleMouseEnter("Who is Winning")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Who is Winning" && (
                <span className="hover-text">Who is Winning?</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Social")}
            >
              <img
                className="social-home-svg"
                src={social}
                alt="svg"
                onMouseEnter={() => handleMouseEnter("Social")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Social" && (
                <span className="hover-text">Social</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Puzzles")}
            >
              <img
                className="puzzles-home-svg"
                src={puzzles}
                alt="svg"
                style={{ width: "33px" }}
                onMouseEnter={() => handleMouseEnter("Puzzles")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Puzzles" && (
                <span className="hover-text">Puzzles</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/More")}
            >
              <img
                className="more-home-svg"
                src={more}
                alt="svg"
                style={{ width: "26px" }}
                onMouseEnter={() => handleMouseEnter("More")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "More" && <span className="hover-text">More</span>}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Subscription")}
            >
              <img
                className="subscription-home-svg"
                src={subscription}
                alt="svg"
                style={{ width: "32px" }}
                onMouseEnter={() => handleMouseEnter("Subscription")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Subscription" && (
                <span className="hover-text">Subscription</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={() => handleNavigation("/Settings")}
            >
              <img
                className="settings-home-svg"
                src={settings}
                alt="svg"
                style={{ width: "23px" }}
                onMouseEnter={() => handleMouseEnter("Settings")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Settings" && (
                <span className="hover-text">Settings</span>
              )}
            </div>
            <div
              className="img-home-div"
              onClick={handleLogout}
              style={{ cursor: "pointer" }}
            >
              <img
                className="logout-home-svg"
                src={logout}
                alt="svg"
                style={{ width: "23px" }}
                onMouseEnter={() => handleMouseEnter("Logout")}
                onMouseLeave={handleMouseLeave}
              />
              {hovered === "Logout" && (
                <span className="hover-text">Logout</span>
              )}
            </div>
          </div>
        )}

        <div
          className={`collapse-leftbar-home-div home-phone-nonessential ${
            collapsed ? "collapsed" : ""
          }`}
          onClick={toggleCollapse}
        >
          <img
            className="collapse-leftbar-home"
            src={collapseLeftbar}
            alt="svg"
          />
          <img
            className={`collapse-leftarrow-home ${
              collapsed ? "collapsed" : ""
            }`}
            src={collapsed ? right : left}
            alt="svg"
          />
        </div>

        <div className="center-home">
          <div className="center-home-columns">
            <div className="center-slider-home home-phone-carousel">
              {puzzleCarousels.map((puzzleType, puzzleTypeIndex) => {
                const { id, image, title, path } = puzzleType;

                let position = "nextSlide";
                if (puzzleTypeIndex === index) {
                  position = "activeSlide";
                }
                if (
                  puzzleTypeIndex === index - 1 ||
                  (index === 0 &&
                    puzzleTypeIndex === puzzleCarousels.length - 1)
                ) {
                  position = "lastSlide";
                }

                return (
                  <article
                    className={position}
                    id="center-board1-div"
                    key={id}
                    onClick={() => handleNavigation(path)}
                  >
                    <img src={image} className="center-board1-svg" alt="svg" />
                    <div className="center-puzzles-button">{title}</div>
                  </article>
                );
              })}

              <div
                className="center-slider-left"
                onClick={() => setIndex(index - 1)}
              >
                <img src={right} className="center-slider-left-arrow" />
              </div>

              <div
                className="center-slider-right"
                onClick={() => setIndex(index + 1)}
              >
                <img src={right} className="center-slider-right-arrow" />
              </div>
            </div>

            <div className="center-points-leaderboard-div home-phone-nonessential">
              <div className="center-points-title-div">
                <h2 className="center-points-leaderboard-title">
                  Points Leaderboard
                </h2>
                <img
                  src={rightArrow}
                  className="center-right-arrow-points"
                  alt="svg"
                  onClick={() => handleNavigation("/Points")}
                />
              </div>

              <div className="search-center-home">
                <div className="search-bg-center-home">
                  <img
                    src={searchSvg}
                    className="search-center-home-svg"
                    alt="svg"
                  />
                </div>
                <form className="form-search-center">
                  <input
                    type="text"
                    placeholder="Search user"
                    className="search-input-center-home"
                    onChange={(e) => setSearchUser(e.target.value)}
                  />
                </form>
              </div>

              <div className="center-user-title-div">
                <div className="center-user-title">User</div>
                <img
                  src={points}
                  className="center-user-points-svg"
                  alt="svg"
                />
              </div>
              <br />
              <div className="center-users-div">
                <div className="center-points-user1">1. royy03</div>
                <div className="center-points-points1">385</div>
              </div>
              <div className="center-users-div">
                <div className="center-points-user2">2. xoxo</div>
                <div className="center-points-points2">329</div>
              </div>
              <div className="center-users-div">
                <div className="center-points-user3">3. jollibre</div>
                <div className="center-points-points3">76</div>
              </div>
              <div className="center-users-div">
                <div className="center-points-user4">4. polopaul</div>
                <div className="center-points-points4">57</div>
              </div>
              <div className="center-users-div">
                <div className="center-points-user5">5. marco8093</div>
                <div className="center-points-points5">34</div>
              </div>
            </div>
          </div>

          <div className="center-home-row2 home-phone-nonessential">
            <div className="center-game-review-home">
              <div
                className="review-board-home-div"
                onClick={() => handleNavigation("/GameReview")}
              >
                <div className="review-opponent-name-home">ManoelBr (2071)</div>
                <img
                  src={gameReviewBoard}
                  className="game-review-board-home"
                  alt="svg"
                />
                <div className="review-user-name-home">Snehal2703 (2103)</div>
              </div>

              <div className="review-text-home-div">
                <h2 className="game-review-title-home">GAME REVIEW</h2>
                <div className="game-review-text-home">
                  Review game against ManoelBr
                </div>
                <img
                  src={gameReviewCenter}
                  className="game-review-svg-center"
                  onClick={() => handleNavigation("/GameReview")}
                />
                <button
                  className="game-review-button-home"
                  onClick={() => handleNavigation("/GameArchive")}
                >
                  Go to game archive
                </button>
              </div>
            </div>

            <div className="center-daily-puzzle-home">
              <div className="center-daily-puzzle-date">27/04/2024</div>
              <div className="center-daily-puzzle-title">DAILY PUZZLE</div>
              <img
                src={dailyPuzzleBoard}
                className="center-daily-puzzle-board"
                alt="svg"
                onClick={() => handleNavigation("/DailyPuzzle")}
              />
            </div>

            <div className="center-stats-home">
              <div className="center-stats-title-div">
                <h2 className="center-stats-home-title">Stats</h2>
                <img
                  src={rightArrow}
                  className="center-stats-right-arrow"
                  alt="svg"
                  onClick={() => handleNavigation("/Stats")}
                />
              </div>

              <div className="center-stats-row1-div">
                <div className="center-stats-con1-div">
                  <div className="center-stats-con1">1296</div>
                  <div className="center-stats-con1-text">Tactics</div>
                </div>

                <div className="center-stats-con1-div">
                  <div className="center-stats-con2">566</div>
                  <div className="center-stats-con1-text">Visualisation</div>
                </div>

                <div className="center-stats-con1-div">
                  <div className="center-stats-con3">843</div>
                  <div className="center-stats-con1-text">Openings</div>
                </div>
              </div>

              <div className="center-stats-row1-div">
                <div className="center-stats-con1-div">
                  <div className="center-stats-con1">815</div>
                  <div className="center-stats-con1-text">Puzzle clash</div>
                </div>

                <div className="center-stats-con1-div">
                  <div className="center-stats-con2-performance">8.9</div>
                  <div className="center-stats-con1-text">Performance</div>
                </div>
              </div>
            </div>
          </div>

          <div className="center-home-row3 home-phone-nonessential">
            <div className="center-live-puzzles-home">
              <h2 className="center-live-puzzles-title">LIVE PUZZLES</h2>
              <div className="center-puzzle-boards-home">
                <div className="center-rush-div">
                  <div
                    className="center-rush-images-div"
                    onClick={() => handleNavigation("/PuzzleRush")}
                  >
                    <img
                      src={puzzleRushBoard}
                      className="center-puzzle-rush-svg"
                      alt="svg"
                    />
                    <img
                      src={puzzleRushIcon}
                      className="center-puzzle-rush-icon"
                      alt="svg"
                    />
                  </div>
                  <button
                    className="center-puzzle-rush-button"
                    onClick={() => handleNavigation("/PuzzleRush")}
                  >
                    Puzzle rush
                  </button>
                </div>

                <div className="center-battle-div">
                  <div
                    className="center-battle-images-div"
                    onClick={() => handleNavigation("/PuzzleBattle")}
                  >
                    <img
                      src={puzzleBattleBoard}
                      className="center-puzzle-battle-svg"
                      alt="svg"
                    />
                    <img
                      src={puzzleBattleIcon}
                      className="center-puzzle-battle-icon"
                      alt="svg"
                    />
                  </div>
                  <button
                    className="center-puzzle-battle-button"
                    onClick={() => handleNavigation("/PuzzleBattle")}
                  >
                    Puzzle battle
                  </button>
                </div>
              </div>
            </div>

            <div className="center-vs-bot-home">
              <div className="center-challenge-bot-title">v/s Bot</div>

              <div
                className="center-bot-image-div"
                onClick={() => handleNavigation("/Bot")}
              >
                <img
                  src={challengeBotBoard}
                  className="center-challenge-bot-svg"
                  alt="svg"
                />
                <img
                  src={challengeBotIcon}
                  className="center-challenge-bot-icon"
                  alt="svg"
                />
              </div>
              <button
                className="center-challenge-bot-button"
                onClick={() => handleNavigation("/Bot")}
              >
                Challenge
              </button>
            </div>

            <div className="center-compare-home">
              <div className="center-compare-title-div">
                <h2 className="center-compare-home-title">Compare a user</h2>
                <img
                  src={rightArrow}
                  className="center-compare-right-arrow"
                  alt="svg"
                  onClick={() => handleNavigation("/Compare")}
                />
              </div>

              <div className="center-compare-div">
                <div className="center-compare-user-div">
                  <img
                    src={profile}
                    className="center-compare-profile-svg"
                    alt="svg"
                  />
                  <form className="center-compare-user-form">
                    <input
                      type="text"
                      placeholder="Snehal2703"
                      className="center-compare-user-search"
                    />
                  </form>
                  <div className="center-compare-user-games">GAMES - 1826</div>
                  <div className="center-compare-wld">
                    <div className="center-compare-w">
                      W<br />
                      912
                    </div>
                    <div className="center-compare-d">
                      D<br />
                      76
                    </div>
                    <div className="center-compare-l">
                      L<br />
                      838
                    </div>
                  </div>
                </div>
                <div className="center-compare-svg-div">
                  <img src={compare} className="center-compare-svg" alt="svg" />
                  <div className="center-compare-line" />
                </div>

                <div className="center-compare-opponent-div">
                  <img
                    src={opponent}
                    className="center-compare-opponent-svg"
                    alt="svg"
                  />
                  <form className="center-compare-opponent-form">
                    <input
                      type="text"
                      placeholder="Chezzle username"
                      className="center-compare-opponent-search"
                    />
                  </form>
                  <img
                    src={question}
                    className="center-compare-question-svg"
                    alt="svg"
                  />
                </div>
              </div>
              <button
                className="center-compare-evaluate-button"
                onClick={() => handleNavigation("/Compare")}
              >
                Evaluate
              </button>
            </div>
          </div>

          <div className="center-home-game-registry home-phone-nonessential">
            <div className="center-registry-title-complete">
              <div className="center-registry-title-div">
                <div className="center-registry-title">Game registry</div>
                <img src={gameRegistry} className="center-registry-svg" />
              </div>

              <div className="center-registry-performance-div">
                <div className="center-registry-title-performance">
                  Performance
                </div>
                <div className="center-registry-title-performanceValue">
                  8.9
                </div>
              </div>
            </div>

            <div className="center-registry-body-div">
              <div className="center-registry-search">
                <div className="center-registry-search-div">
                  <div className="registry-bg-header-search">
                    <img
                      src={searchSvg}
                      className="registry-search-home-svg"
                      alt="svg"
                    />
                  </div>
                  <form className="form-search-registry">
                    <input
                      type="text"
                      placeholder="Search a game"
                      className="registry-input-header-search"
                    />
                  </form>
                </div>

                <button className="center-registry-filter-button">
                  Filter{" "}
                  <img
                    src={filterIcon}
                    className="center-registry-filter-svg"
                    alt="svg"
                  />
                </button>
              </div>

              <div className="registry-table-heading-div">
                <div className="registry-heading-game1">Game</div>
                <div className="registry-heading-game">Format</div>
                <div className="registry-heading-game">Outcome</div>
                <div className="registry-heading-game">Date</div>
                <div className="registry-heading-game">Performance Ratio</div>
                <div className="registry-heading-game">Graph</div>
                <div className="registry-heading-game">Source</div>
              </div>

              <div className="registry-table-home">
                <div className="registry-table-game1">
                  Snehal2703 vs Markamenta
                </div>
                <div className="registry-table-game">10 | 0</div>
                <div className="registry-table-game">1 - 0</div>
                <div className="registry-table-game">15 July, 2024</div>
                <div className="registry-table-game">8.3 - 7.2</div>
                <div className="registry-table-graph-svg">
                  <img src={graphRegistry} />
                </div>
                <div className="registry-table-game">Lichess.org</div>
              </div>

              <div className="registry-table-home">
                <div className="registry-table-game1">
                  Markamenta vs Snehal2703
                </div>
                <div className="registry-table-game">10 | 0</div>
                <div className="registry-table-game">1 - 0</div>
                <div className="registry-table-game">01 July, 2024</div>
                <div className="registry-table-game">9.1 - 9.2</div>
                <div className="registry-table-graph-svg">
                  <img src={graphRegistry} />
                </div>
                <div className="registry-table-game">Lichess.org</div>
              </div>
              <div className="registry-table-home">
                <div className="registry-table-game1">Snehal2703 vs Aces42</div>
                <div className="registry-table-game">3 | 0</div>
                <div className="registry-table-game">0 - 1</div>
                <div className="registry-table-game">03 June, 2024</div>
                <div className="registry-table-game">7.4 - 6.2</div>
                <div className="registry-table-graph-svg">
                  <img src={graphRegistry} />
                </div>
                <div className="registry-table-game">Chess.com</div>
              </div>
              <div className="registry-table-home">
                <div className="registry-table-game1">
                  Chezzelcom vs Snehal2703
                </div>
                <div className="registry-table-game">1 | 0</div>
                <div className="registry-table-game">1 - 0</div>
                <div className="registry-table-game">01 June, 2024</div>
                <div className="registry-table-game">7.8 - 5.8</div>
                <div className="registry-table-graph-svg">
                  <img src={graphRegistry} />
                </div>
                <div className="registry-table-game">Lichess.org</div>
              </div>
              <div className="registry-table-home">
                <div className="registry-table-game1">
                  Snehal2703 vs DrGruenfeld
                </div>
                <div className="registry-table-game">10 | 0</div>
                <div className="registry-table-game">0 - 1</div>
                <div className="registry-table-game">15 April, 2024</div>
                <div className="registry-table-game">9.5 - 9.1</div>
                <div className="registry-table-graph-svg">
                  <img src={graphRegistry} />
                </div>
                <div className="registry-table-game">Chess.com</div>
              </div>
              <div className="registry-table-home">
                <div className="registry-table-game1">
                  Limitedtheory vs Snehal2703
                </div>
                <div className="registry-table-game">3 | 0</div>
                <div className="registry-table-game">1 - 0</div>
                <div className="registry-table-game">01 February, 2024</div>
                <div className="registry-table-game">7.1 - 6.6</div>
                <div className="registry-table-graph-svg">
                  <img src={graphRegistry} />
                </div>
                <div className="registry-table-game">Chess.com</div>
              </div>

              <div className="registry-page-change-review">
                <div className="registry-page-div">
                  <img
                    src={leftPage}
                    className="registry-page-left-svg"
                    alt="svg"
                  />
                  <div className="registry-page1">1</div>
                  <div className="registry-pages">2</div>
                  <div className="registry-pages">3</div>
                  <div className="registry-pages-dots">...</div>
                  <div className="registry-pages">6</div>
                  <img
                    src={leftPage}
                    className="registry-page-right-svg"
                    alt="svg"
                  />
                </div>
                <button
                  className="registry-review-games-button"
                  onClick={() => handleNavigation("/GameReview")}
                >
                  Review more games{" "}
                  <img
                    src={searchReview}
                    className="registry-review-games-svg"
                    alt="svg"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-home-div home-phone-nonessential">
        <div className="footer-home-logo-subscription">
          <div className="footer-home-logo-div">
            <img className="logo-image-footer" src={logo} alt="logo" />
            <div className="logo-text-footer">
              <span className="C-logo-footer">C</span>
              <span className="hezzle-logo-footer">
                he<span className="Z-1-footer">Z</span>
                <span className="Z-2-footer">Z</span>le
              </span>
            </div>
          </div>
          <button
            className="footer-button-subscription-div"
            onClick={() => handleNavigation("/Subscription")}
          >
            Get subscription{" "}
            <img src={subscription} className="footer-subscription-svg" />
          </button>
        </div>
        <div className="footer-text-complete-div">
          <div className="footer-english-about-careers">
            <div className="footer-english-div">
              English{" "}
              <img
                src={downFooter}
                className="footer-english-up-svg"
                alt="svg"
              />
            </div>
            <div className="footer-about-div">About us</div>
            <div className="footer-careers-div">Careers</div>
          </div>

          <div className="footer-tutorial-why-faqs">
            <div className="footer-tutorial-div">Tutorial</div>
            <div className="footer-whyChezzle-div">Why Chezzle</div>
            <div className="footer-faqs-div">FAQs</div>
          </div>

          <div className="footer-advertise-people-contact">
            <div className="footer-advertise-div">Advertise</div>
            <div className="footer-people-div">Our people</div>
            <div className="footer-contact-div">Contact Us</div>
          </div>
        </div>
        <div className="footer-logos-copyrights">
          <div className="footer-logos-div">
            <img src={instaSvg} className="footer-insta-svg" alt="svg" />
            <img src={youtubeSvg} className="footer-youtube-svg" alt="svg" />
            <img src={threadsSvg} className="footer-threads-svg" alt="svg" />
            <img src={twitterSvg} className="footer-twitter-svg" alt="svg" />
            <img src={linkedninSvg} className="footer-linkedin-svg" alt="svg" />
          </div>

          <div className="footer-copyrights-terms-div">
            <div className="footer-copyrights-div">
              <img src={copyrightsSvg} className="footer-copyrights-svg" />
              2024 Chezzle. All rights reserved.
            </div>
            <div className="footer-terms-div">Terms</div>
            <div className="footer-cookies-div">Cookies</div>
            <div className="footer-privacy-div">Privacy</div>
            <div className="footer-report-div">Report a problem</div>
          </div>
        </div>
      </div>
    </div>
  );
};
